export function getClinicIcon(): string {
  return `
  <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M10 1.77539H6V6.77539L1 6.77539V10.7754H6V15.7754H10V10.7754H15V6.77539L10 6.77539V1.77539Z" fill="currentColor" />
  </svg>
`;
}
